import React from "react"
class TechBox extends React.Component {

    render() {
        let classes = "tab-btn"
        if (this.props.isActive) {
            classes = "tab-btn active-btn"
        }

        return (
            <li data-tab="service-brain" className={classes} onClick={this.props.onClick}>
                <span className="icon">
                    <img src={""} alt="" />
                </span>
                {this.props.title}

            </li>
        )
    }
}
export default TechBox